import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Router from "next/router";

import Chip from "@kikoff/components/src/v1/info/Chip";

import { StyledButton, UnderlineButton } from "@component/buttons/buttons";
import ViewTemplate from "@component/dashboard/offer/view_template";
import WithFooter from "@component/dashboard/offer/with_footer";
import { PageRegistration } from "@component/flows/hooks/usePageFlow";
import PageAlign from "@component/landing/page_align";
import Line from "@component/line";
import { selectHasPaymentMethod } from "@feature/funds";
import { track } from "@util/analytics";
import { nativeDispatch } from "@util/mobile";

import biker from "./images/biker.png";

import styles from "./styles.module.scss";

interface CbsUpsellViewProps extends PageRegistration {}

export default function CbsUpsellView({
  configFlow,
  Button,
}: CbsUpsellViewProps) {
  configFlow.button(
    <Button
      variant="primary-outline"
      onClick={() => {
        track.tap("CBL - Immediate Upsell - Maybe Later Button");
      }}
    >
      Maybe later
    </Button>
  );

  const hasPaymentMethod = useSelector(selectHasPaymentMethod());

  useEffect(() => {
    track.impression("CBL - Immediate Upsell");
  }, []);
  const content = (
    <ViewTemplate className={styles["upsell-wrapper"]}>
      {hasPaymentMethod ? (
        <h2>Hooray! You’ve started building positive payment history</h2>
      ) : (
        <div className={styles["missing-payment-reminder"]}>
          <h2>
            It’s really important to make monthly payments on time.
            <br />
            <UnderlineButton
              onClick={() => {
                track.tap(
                  "CBL - Immediate Upsell - Add Payment Method Button",
                  {
                    "screen name": "payment",
                  }
                );
                if (!nativeDispatch("close"))
                  Router.push("/dashboard/store/setup-repayment");
              }}
            >
              Add payment method
            </UnderlineButton>
          </h2>
        </div>
      )}
      <Line />
      <div>
        <header className={styles["upsell-text"]}>
          Build even more credit with our Credit Builder Loan.{" "}
          <Chip
            inline
            className={styles["pill"]}
            text="NEW"
            colorHex="#8A74B8"
          />
        </header>
      </div>
      <div className={styles["graphic-wrapper"]}>
        <img src={biker.src} className={styles["biker-graphic"]} />
      </div>
      <p>It’s another loan that can be reported to the bureaus!</p>
    </ViewTemplate>
  );

  return (
    <WithFooter
      footer={
        <PageAlign>
          <StyledButton
            shape="round"
            className={styles["upsell-button"]}
            onClick={async () => {
              track.tap("CBL - Immediate Upsell - Learn More Button");
              Router.push("/dashboard/offer/credit-builder-savings");
            }}
          >
            <div>Learn more</div>
          </StyledButton>
        </PageAlign>
      }
    >
      {content}
    </WithFooter>
  );
}
